/**
 * Step Up For Students / EMA Marketplace constants.
 *
 * Single source of truth for everything families need to find Playce Academy
 * inside the EMA Marketplace ("Find Providers"). These were previously
 * hardcoded in four screens and "kept in sync manually" — import from here
 * instead.
 *
 * The BRAND is always "Playce Academy". EMA_PROVIDER_SEARCH_NAME is the exact
 * listing string families type into the EMA search box — use it ONLY inside
 * "search this exact name" instructions, never as the brand in headlines,
 * meta tags, or body copy.
 *
 * The VALUE is Aubrey's chosen EMA listing name (set the EMA location name to
 * match). Whether it's exactly right is an owner decision — change it here
 * only, and only on his say-so.
 */
export const EMA_PROVIDER_SEARCH_NAME = "Playce Academy Athletics";

/**
 * The EMA "service offering" families reserve against. "Fitness Classes" was
 * confirmed against the live EMA Service Offerings list; the PE
 * categorization decision (2026-07-05) is about how EMA classifies the
 * provider, not this string. Change only on Aubrey's say-so.
 */
export const EMA_OFFERING_NAME = "Fitness Classes";

/**
 * Where families sign in to reserve their scholarship funds. Step Up's
 * marketplace lives behind the family login on the main site, so the homepage
 * is the stable entry point (deep links into EMA require a session).
 */
export const EMA_MARKETPLACE_URL = "https://www.stepupforstudents.org/";

/** How to apply for a Step Up scholarship (PEP / FES-UA). */
export const STEP_UP_APPLY_URL = "https://www.stepupforstudents.org/";
